// 移动端router
export const mRouter = [{
  path: '/mhome',
  name: 'mhome',
  component: () => import('@/pages/mobile/m_home'),
  meta: {
    keepAlive: false,
    title: '畅为中台云',
    isMobile: true
  }
},
{
  path: '/mindex',
  name: 'mindex',
  component: () => import('@/pages/mobile/m_index'),
  meta: {
    keepAlive: false,
    title: 'MRO工业品一站式采购商城平台_畅为中台云',
    isMobile: true
  }
},
{
  path: '/mcategory',
  name: 'mcategory',
  component: () => import('@/pages/mobile/m_category'),
  meta: {
    keepAlive: false,
    title: '分类',
    isMobile: true
  }
},
{
  path: '/mcart',
  name: 'mcart',
  component: () => import('@/pages/mobile/m_cart'),
  meta: {
    keepAlive: false,
    title: '购物车',
    isMobile: true
  }
},

{
  path: '/mmine',
  name: 'mmine',
  component: () => import('@/pages/mobile/m_mine'),
  meta: {
    keepAlive: false,
    title: '我的',
    isMobile: true
  },
  children: []
}, {
  path: '/mbrand',
  name: 'mbrand',
  component: () => import('@/pages/mobile/m_brand'),
  meta: {
    keepAlive: false,
    title: '品牌',
    isMobile: true
  }
},
{
  path: '/mintegralMall',
  name: 'mintegralMall',
  component: () => import('@/pages/mobile/m_integralMall'),
  meta: {
    keepAlive: false,
    title: '积分商城',
    isMobile: true
  }
},
{
  path: '/mpromotion',
  name: 'mpromotion',
  component: () => import('@/pages/mobile/m_promotion'),
  meta: {
    keepAlive: false,
    title: '优惠促销',
    isMobile: true
  }
},
{
  path: '/mcase',
  name: 'mcase',
  component: () => import('@/pages/mobile/m_case'),
  meta: {
    keepAlive: false,
    title: '解决方案',
    isMobile: true
  }
},
{
  path: '/mnews',
  name: 'mnews',
  component: () => import('@/pages/mobile/m_news'),
  meta: {
    keepAlive: false,
    title: '咨询',
    isMobile: true
  }
},
{
  path: '/msetting',
  name: 'msetting',
  component: () => import('@/pages/mobile/m_setting'),
  meta: {
    keepAlive: false,
    title: '设置',
    isMobile: true
  }
},
{
  path: '/msearch',
  name: 'mseach',
  component: () => import('@/pages/mobile/m_search'),
  meta: {
    keepAlive: false,
    title: '搜索',
    isMobile: true
  }
},
{
  path: '/mfeedback',
  name: 'mfeedback',
  component: () => import('@/pages/mobile/m_feedback'),
  meta: {
    keepAlive: false,
    title: '意见反馈',
    isMobile: true
  }
},
{
  path: '/msearchResult',
  name: 'msearchResult',
  component: () => import('@/pages/mobile/m_searchResult'),
  meta: {
    keepAlive: false,
    title: '搜索',
    isMobile: true
  }
},
{
  name: 'mcompare',
  component: () => import('@/pages/mobile/m_compare'),
  path: '/mcompare',
  meta: {
    keepAlive: false,
    title: '比价',
    isMobile: true
  }
},
{
  name: 'mcompareResult',
  component: () => import('@/pages/mobile/m_compareResult'),
  path: '/mcompareResult',
  meta: {
    keepAlive: false,
    title: '比价结果',
    isMobile: true
  }
},
{
  path: '/mmessageCenter',
  name: 'mmessageCenter',
  component: () => import('@/pages/mobile/m_messageCenter'),
  meta: {
    keepAlive: false,
    title: '信息中心',
    isMobile: true
  }
},
{
  path: '/mgoodsDetail',
  name: 'mgoodsDetail',
  component: () => import('@/pages/mobile/m_goodsDetail'),
  meta: {
    keepAlive: false,
    title: '商品详情',
    isMobile: true
  }
},
{
  path: '/mlogin',
  name: 'mlogin',
  component: () => import('@/pages/mobile/m_login'),
  meta: {
    keepAlive: false,
    title: '登录',
    isMobile: true
  }
},
{

  path: '/mregister',
  name: 'mregister',
  component: () => import('@/pages/mobile/m_register'),
  meta: {
    keepAlive: false,
    title: '注册',
    isMobile: true
  }
},
{
  path: '/mforgot',
  name: 'mforgot',
  component: () => import('@/pages/mobile/m_forgot'),
  meta: {
    keepAlive: false,
    title: '注册',
    isMobile: true
  }
},
{
  path: '/mintegralGoodsDetail',
  name: 'mintegralGoodsDetail',
  component: () => import('@/pages/mobile/m_integralGoodsDetail'),
  meta: {
    keepAlive: false,
    title: '积分商品产品详情',
    isMobile: true
  }
},
{
  path: '/mintegralDetail',
  name: 'mintegralDetail',
  component: () => import('@/pages/mobile/m_integralDetail'),
  meta: {
    keepAlive: false,
    title: '积分明细',
    isMobile: true
  }
},
{
  path: '/mhistroy',
  name: 'mhistroy',
  component: () => import('@/pages/mobile/m_histroy'),
  meta: {
    keepAlive: false,
    title: '浏览足迹',
    isMobile: true
  }
},
{
  path: '/maddress',
  name: 'maddress',
  component: () => import('@/pages/mobile/m_address'),
  meta: {
    keepAlive: false,
    title: '地址管理',
    isMobile: true
  }
},
{
  path: '/morder',
  name: 'morder',
  component: () => import('@/pages/mobile/m_order'),
  meta: {
    keepAlive: false,
    title: '订单管理',
    isMobile: true
  }
},
{
  path: '/minfo',
  name: 'minfo',
  component: () => import('@/pages/mobile/m_info'),
  meta: {
    keepAlive: false,
    title: '个人资料',
    isMobile: true
  }
},
{
  path: '/mpromotionDetail',
  name: 'mpromotionDetail',
  component: () => import('@/pages/mobile/m_promotionDetail'),
  meta: {
    keepAlive: false,
    title: '个人资料',
    isMobile: true
  }
},
{
  path: '/mqa',
  name: 'mqa',
  component: () => import('@/pages/mobile/m_qa'),
  meta: {
    keepAlive: false,
    title: '问题',
    isMobile: true
  }
},
{
  path: '/morder',
  name: 'morder',
  component: () => import('@/pages/mobile/m_order'),
  meta: {
    keepAlive: false,
    title: '订单列表',
    isMobile: true
  }
},
{
  path: '/morderDetail',
  name: 'morderDetail',
  component: () => import('@/pages/mobile/m_orderDetail'),
  meta: {
    keepAlive: false,
    title: '订单详情',
    isMobile: true
  }
},
{
  path: '/mlogisti',
  name: 'mlogisti',
  component: () => import('@/pages/mobile/m_logisti'),
  meta: {
    keepAlive: false,
    title: '物流详情',
    isMobile: true
  }
},
{
  path: '/mtakeDelivery',
  name: 'mtakeDelivery',
  component: () => import('@/pages/mobile/m_takeDelivery'),
  meta: {
    keepAlive: false,
    title: '添加提货函',
    isMobile: true
  }
},
{
  path: '/mpaymentForm',
  name: 'mpaymentForm',
  component: () => import('@/pages/mobile/m_paymentForm'),
  meta: {
    keepAlive: false,
    title: '银行转账付款单',
    isMobile: true
  }
},
{
  path: '/mpaymentVoucher',
  name: 'mpaymentVoucher',
  component: () => import('@/pages/mobile/m_paymentVoucher'),
  meta: {
    keepAlive: false,
    title: '银行转账付款单',
    isMobile: true
  }
},
{
  path: '/morderConfirm',
  name: 'morderConfirm',
  component: () => import('@/pages/mobile/m_orderConfirm'),
  meta: {
    keepAlive: false,
    title: '填写订单',
    isMobile: true
  }
},
{
  path: '/maddressAdd',
  name: 'maddressAdd',
  component: () => import('@/pages/mobile/m_addressAdd'),
  meta: {
    keepAlive: false,
    title: '填写地址',
    isMobile: true
  }
},
{
  path: '/mwarehouse',
  name: 'mwarehouse',
  component: () => import('@/pages/mobile/m_warehouse'),
  meta: {
    keepAlive: false,
    title: '提货地址',
    isMobile: true
  }
},
{
  path: '/mcloudWarehouse',
  name: 'mcloudWarehouse',
  component: () => import('@/pages/mobile/m_cloudWarehouse'),
  meta: {
    keepAlive: false,
    title: '选择云仓',
    isMobile: true
  }
},
{
  path: '/mbrandDetail',
  name: 'mbrandDetail',
  component: () => import('@/pages/mobile/m_brandDetail'),
  meta: {
    keepAlive: false,
    title: '品牌详情',
    isMobile: true
  }
},
{
  path: '/mpayment',
  name: 'mpayment',
  component: () => import('@/pages/mobile/m_payment'),
  meta: {
    keepAlive: false,
    title: '线上支付',
    isMobile: true
  }
},
{
  path: '/mpaymentOffline',
  name: 'mpaymentOffline',
  component: () => import('@/pages/mobile/m_paymentOffline'),
  meta: {
    keepAlive: false,
    title: '线下支付',
    isMobile: true
  }
},
{
  path: '/mmessage',
  name: 'mmessage',
  component: () => import('@/pages/mobile/m_message'),
  meta: {
    keepAlive: false,
    title: '消息中心',
    isMobile: true
  }
},
{
  path: '/mexchange',
  name: 'mexchange',
  component: () => import('@/pages/mobile/m_exchange'),
  meta: {
    keepAlive: false,
    title: '积分兑换',
    isMobile: true
  }
},
{
  path: '/mcomment',
  name: 'mcomment',
  component: () => import('@/pages/mobile/m_comment'),
  meta: {
    keepAlive: false,
    title: '产品评价',
    isMobile: true
  }
},
{
  path: '/mcommentList',
  name: 'mcommentList',
  component: () => import('@/pages/mobile/m_commentList'),
  meta: {
    keepAlive: false,
    title: '产品评价',
    isMobile: true
  }
},
{
  path: '/morderTeam',
  name: 'morderTeam',
  component: () => import('@/pages/mobile/m_orderTeam'),
  meta: {
    keepAlive: false,
    title: '团购订单',
    isMobile: true
  }
},
{
  path: '/mcontract',
  name: 'mcontract',
  component: () => import('@/pages/mobile/m_contract'),
  meta: {
    keepAlive: false,
    title: '协议管理',
    isMobile: true
  }
},
{
  path: '/mmodelContract',
  name: 'mmodelContract',
  component: () => import('@/pages/mobile/m_modelContract'),
  meta: {
    keepAlive: false,
    title: '合同范本 - 畅为',
    isMobile: true
  }
},
{
  path: '/mmodelContractContent',
  name: 'mmodelContractContent',
  component: () => import('@/pages/mobile/m_modelContractContent'),
  meta: {
    keepAlive: false,
    title: '合同范本 - 畅为',
    isMobile: true
  }
},
{
  path: '/mmodelProjectDeatil',
  name: 'mmodelProjectDeatil',
  component: () => import('@/pages/mobile/m_modelProjectDeatil'),
  meta: {
    keepAlive: false,
    title: '项目附录详情',
    isMobile: true
  }
},
{
  path: '/mcanExchange',
  name: 'mcanExchange',
  component: () => import('@/pages/mobile/m_canExchange'),
  meta: {
    keepAlive: false,
    title: '我能兑换',
    isMobile: true
  }
},
{
  path: '/mask',
  name: 'mask',
  component: () => import('@/pages/mobile/m_ask'),
  meta: {
    keepAlive: false,
    title: '发布问题',
    isMobile: true
  }
},
{
  path: '/mtrack',
  name: 'mtrack',
  component: () => import('@/pages/mobile/m_track'),
  meta: {
    keepAlive: false,
    title: '车辆跟踪',
    isMobile: true
  }
},
{
  path: '/mdeliveryOrder',
  name: 'mdeliveryOrder',
  component: () => import('@/pages/mobile/m_deliveryOrder'),
  meta: {
    keepAlive: false,
    title: '提货单',
    isMobile: true
  }
},
{
  path: '/mdeliveryOrderDetail',
  name: 'mdeliveryOrderDetail',
  component: () => import('@/pages/mobile/m_deliveryOrderDetail'),
  meta: {
    keepAlive: false,
    title: '提货单详情',
    isMobile: true
  }
},
{
  path: '/mrefund',
  name: 'mrefund',
  component: () => import('@/pages/mobile/m_refund'),
  meta: {
    keepAlive: false,
    title: '申请退货',
    isMobile: true
  }
},
{
  path: '/mactivity',
  name: 'mactivity',
  component: () => import('@/pages/mobile/m_activity'),
  meta: {
    keepAlive: false,
    title: '活动',
    isMobile: true
  }
},
{
  path: '/mintegralList',
  name: 'mintegralList',
  component: () => import('@/pages/mobile/m_integralList'),
  meta: {
    keepAlive: false,
    title: '积分订单',
    isMobile: true
  }
},
{
  path: '/mbill',
  name: 'mbill',
  component: () => import('@/pages/mobile/m_bill'),
  meta: {
    keepAlive: false,
    title: '对账单',
    isMobile: true
  }
},
{
  path: '/mfav',
  name: 'mfav',
  component: () => import('@/pages/mobile/m_fav'),
  meta: {
    keepAlive: false,
    title: '收藏夹',
    isMobile: true
  }
},
{
  path: '/mcoupon',
  name: 'mcoupon',
  component: () => import('@/pages/mobile/m_coupon'),
  meta: {
    keepAlive: false,
    title: '优惠券',
    isMobile: true
  }
},
{
  path: '/maddressList',
  name: 'maddressList',
  component: () => import('@/pages/mobile/m_addressList'),
  meta: {
    keepAlive: false,
    title: '地址管理',
    isMobile: true
  }
},
{
  path: '/minvoice',
  name: 'minvoice',
  component: () => import('@/pages/mobile/m_invoice'),
  meta: {
    keepAlive: false,
    title: '发票管理',
    isMobile: true
  }
},
{
  path: '/maccount',
  name: 'maccount',
  component: () => import('@/pages/mobile/m_account'),
  meta: {
    keepAlive: false,
    title: '我的账户',
    isMobile: true
  }
},
{
  path: '/mbank',
  name: 'mbank',
  component: () => import('@/pages/mobile/m_bank'),
  meta: {
    keepAlive: false,
    title: '我的银行卡',
    isMobile: true
  }
},
{
  path: '/mbankAdd',
  name: 'mbankAdd',
  component: () => import('@/pages/mobile/m_bankAdd'),
  meta: {
    keepAlive: false,
    title: '银行卡添加',
    isMobile: true
  }
},
{
  path: '/minvoiceWrite',
  name: 'minvoiceWrite',
  component: () => import('@/pages/mobile/m_invoiceWrite'),
  meta: {
    keepAlive: false,
    title: '开票信息维护',
    isMobile: true
  }
},
{
  path: '/mneeds',
  name: 'mneeds',
  component: () => import('@/pages/mobile/m_needs'),
  meta: {
    keepAlive: false,
    title: '需求登记',
    isMobile: true
  }
},
{
  path: '/mpurchaseOrders',
  name: 'mpurchaseOrders',
  component: () => import('@/pages/mobile/m_purchaseOrders'),
  meta: {
    keepAlive: false,
    title: '我的采购单',
    isMobile: true
  }
},
{
  path: '/mneedsAdd',
  name: 'mneedsAdd',
  component: () => import('@/pages/mobile/m_needsAdd'),
  meta: {
    keepAlive: false,
    title: '需求登记',
    isMobile: true
  }
},
{
  path: '/mneedsProductAdd',
  name: 'mneedsProductAdd',
  component: () => import('@/pages/mobile/m_needsProductAdd'),
  meta: {
    keepAlive: false,
    title: '需求登记',
    isMobile: true
  }
},
{
  path: '/mcouponAll',
  name: 'mcouponAll',
  component: () => import('@/pages/mobile/m_couponAll'),
  meta: {
    keepAlive: false,
    title: '需求登记',
    isMobile: true
  }
},
{
  path: '/mresetPwd',
  name: 'mresetPwd',
  component: () => import('@/pages/mobile/m_resetPwd'),
  meta: {
    keepAlive: false,
    title: '重置密码',
    isMobile: true
  }
},
{
  path: '/mcloud',
  name: 'mcloud',
  component: () => import('@/pages/mobile/m_cloud'),
  meta: {
    keepAlive: false,
    title: '我的云仓',
    isMobile: true
  }
},
{
  path: '/mcloudDetail',
  name: 'mcloudDetail',
  component: () => import('@/pages/mobile/m_cloudDetail'),
  meta: {
    keepAlive: false,
    title: '云仓详情',
    isMobile: true
  }
},
{
  path: '/mrecharge',
  name: 'mrecharge',
  component: () => import('@/pages/mobile/m_recharge'),
  meta: {
    keepAlive: false,
    title: '充值',
    isMobile: true
  }
},
{
  path: '/mwithdraw',
  name: 'mwithdraw',
  component: () => import('@/pages/mobile/m_withdraw'),
  meta: {
    keepAlive: false,
    title: '提现',
    isMobile: true
  }
},
{
  path: '/mwxauth',
  name: 'mwxAuth',
  component: () => import('@/pages/mobile/m_wxAuth'),
  meta: {
    keepAlive: false,
    title: '微信公众号授权',
    isMobile: true
  }
},
{
  path: '/mbindwx',
  name: 'mbindwx',
  component: () => import('@/pages/mobile/m_bindwx'),
  meta: {
    keepAlive: false,
    title: '微信公众号 - 手机号绑定',
    isMobile: true
  }
},
{
  path: '/mQuestionnaire',
  name: 'mQuestionnaire',
  component: () => import('@/pages/mobile/m_questionnaire'),
  meta: {
    keepAlive: false,
    title: '调查问卷',
    isMobile: true
  }
},
{
  path: '/mContractContent',
  name: 'mContractContent',
  component: () => import('@/pages/mobile/m_contractContent'),
  meta: {
    keepAlive: false,
    title: '协议管理',
    isMobile: true
  }
},
{
  path: '/mProjectAdd',
  name: 'mProjectAdd',
  component: () => import('@/pages/mobile/m_projectAdd'),
  meta: {
    keepAlive: false,
    title: '项目目录添加',
    isMobile: true
  }
},
{
  path: '/mProductAdd',
  name: 'mProductAdd',
  component: () => import('@/pages/mobile/m_productAdd'),
  meta: {
    keepAlive: false,
    title: '产品清单',
    isMobile: true
  }
},
{
  path: '/mListAdd',
  name: 'mListAdd',
  component: () => import('@/pages/mobile/m_listAdd'),
  meta: {
    keepAlive: false,
    title: '产品清单',
    isMobile: true
  }
},
{
  path: '/mImpower',
  name: 'mImpower',
  component: () => import('@/pages/mobile/m_impower'),
  meta: {
    keepAlive: false,
    title: '合作授权查询',
    isMobile: true
  }
},
]



// WEBPACK FOOTER //
// ./src/router/mRouter.js